import { VariationGroup } from 'editor/src/store/variants/types';

export interface VariationGroupsReadiness {
  // every variant has a design, so the snapshot can be exported at all
  hasAllDesignData: boolean;
  // at least one variant carries a design older than the one on the canvas
  hasStaleDesignData: boolean;
}

/**
 * GAPI-47583 — tells whether the designs held for the variants are a faithful
 * picture of the current canvas.
 *
 * A variant is missing its design while its template is still being fetched,
 * and holds a stale one when a design update could not be reflected onto it.
 * In both cases what the host holds is (or is about to become) out of date, so
 * validating it — e.g. on "Continue to mockups" — can report an empty design
 * for variants that actually have one.
 */
const getVariationGroupsReadiness = (variationGroups: VariationGroup[]): VariationGroupsReadiness => {
  let hasAllDesignData = true;
  let hasStaleDesignData = false;

  variationGroups.forEach((group) => {
    group.variationsInfo.forEach(({ designData, designDataStale }) => {
      if (!designData) {
        hasAllDesignData = false;
      } else if (designDataStale) {
        hasStaleDesignData = true;
      }
    });
  });

  return { hasAllDesignData, hasStaleDesignData };
};

export default getVariationGroupsReadiness;
